import styled from "styled-components";
import { themevals } from "theme/themevals";

export const HeaderContainer = styled.div`
  position: relative;
  z-index: 1;
  background-color: #ffffff;
  border-bottom: 1px solid #ebebeb;
  border-radius: 6px 6px 0 0;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  overflow: hidden;
`;

export const HeaderLeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  overflow: hidden;
`;

export const HeaderRightSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  overflow: hidden;
`;

export const HeaderTitle = styled.p`
  margin: 0;
  color: ${themevals.colors.base_800};
  white-space: nowrap;
`;

export const HeaderSubtitle = styled.p`
  margin: 0;
  color: ${themevals.colors.dkgrey};
  white-space: nowrap;
`;

export const HeaderDivider = styled.span`
  color: ${themevals.colors.base_800};
`;
